export default function triggerReactEvent (input, value, eventName = 'input') {
    if (!input) return
    Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set.call(input, value)
    input.dispatchEvent(new Event(eventName, { bubbles: true }))
}